export interface INextStepFlowState {
    flows: INextStep[];
    userLetsGetStartedFlows: ILetsgetStartedFlows[];
    isGetStaredUpdatedInCurrentLoginSession: boolean;
}

export const REMOVE_NEXT_STEP = "REMOVE_NEXT_STEP";
export const REQUEST_NEXT_STEP_FLOW = "REQUEST_NEXT_STEP_FLOW";
export const RECEIVE_NEXT_STEP_FLOW = "RECEIVE_NEXT_STEP_FLOW";
export const REQUEST_LETS_GET_STARTED_FLOW = "REQUEST_LETS_GET_STARTED_FLOW";
export const RECEIVE_LETS_GET_STARTED_FLOW = "RECEIVE_LETS_GET_STARTED_FLOW";
export const UPDATE_GETSTARTED_UPDATE_STATUS = "UPDATE_GETSTARTED_UPDATE_STATUS";
export const HIDE_GET_STARTED_ON_CURRENT_SESSION = "HIDE_GET_STARTED_ON_CURRENT_SESSION";
export const COMPLETE_GET_STARTED_FLOW = "COMPLETE_GET_STARTED_FLOW";

export interface ICompleteGetStartedFlow {
    type: typeof COMPLETE_GET_STARTED_FLOW;
    flowID: number;
}

export interface IRequestNextStepFlowAction {
    type: typeof REQUEST_NEXT_STEP_FLOW;
}

export interface IUpdateGetStartedUpdateStatus {
    type: typeof UPDATE_GETSTARTED_UPDATE_STATUS;
}

export interface IHideGetStartedOnCurrentSession {
    type: typeof HIDE_GET_STARTED_ON_CURRENT_SESSION;
}

export interface IReceiveNextStepFlowAction {
    type: typeof RECEIVE_NEXT_STEP_FLOW;
    flows: INextStep[];
}

export interface IRequestLetsGetStartedFlowAction {
    type: typeof REQUEST_LETS_GET_STARTED_FLOW;
}

export interface IReceiveLetsgetStartedFlowAction {
    type: typeof RECEIVE_LETS_GET_STARTED_FLOW;
    userLetsGetStartedFlows: ILetsgetStartedFlows[];
}

export interface IRemoveNextStep {
    type: typeof REMOVE_NEXT_STEP;
    flowName: string;
}

export type NextStepFlowTypes =
    | ICompleteGetStartedFlow
    | IHideGetStartedOnCurrentSession
    | IRequestNextStepFlowAction
    | IReceiveNextStepFlowAction
    | IRemoveNextStep
    | IReceiveLetsgetStartedFlowAction
    | IRequestLetsGetStartedFlowAction
    | IUpdateGetStartedUpdateStatus;

export interface INextStep {
    flowId?: number;
    flowName?: string;
    flowTypeName?: string;
    flowStepName?: string;
    flowStepId?: number;
    flowStepStatus?: string;
}

export interface ILetsgetStartedFlows {
    flowId?: number;
    flowName?: string;
    flowTypeName?: string;
    flowDescription?: string;
    flowStepName?: string;
    flowStepId?: number;
    flowStepStatus?: string;
}
